import { render } from "./CicsList.vue?vue&type=template&id=abb92630&scoped=true"
import script from "./CicsList.vue?vue&type=script&lang=js"
export * from "./CicsList.vue?vue&type=script&lang=js"

import "./CicsList.vue?vue&type=style&index=0&id=abb92630&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abb92630"]])

export default __exports__